import { render, staticRenderFns } from "./TarifAdd.vue?vue&type=template&id=01f8c40c&scoped=true&"
import script from "./TarifAdd.vue?vue&type=script&lang=js&"
export * from "./TarifAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8c40c",
  null
  
)

export default component.exports